import { toast } from 'react-toastify';

import { callApi } from '../../../../../apiCaller';
import { cloneDeep, toastError } from '../../../../../utils';
import { API_SUBSCRIBER_USER_PROFESSIONAL_FIELD_LICENSE_DETAIL } from '../../../../../constants';

import { setIsLoading, setIsWaiting } from '../../../../../actions/general';
import { setUserProfessionalFieldLicense } from '../../GlobalStates/UserProfessional/actions';

export const API_SUBSCRIBER_USER_PROFESSIONAL_FIELD_LICENSE = 'user/professional-field-license';

export const setUserProfessionalFieldLicenseResponse = (responseData) => (dispatch) => {
     const newUserProfessionalFieldLicense = {};

     if (responseData.length) {
          const userLicense = responseData[0];
          newUserProfessionalFieldLicense.country = userLicense?.country;

          if (responseData.length === 1 && userLicense.country !== 'US') {
               newUserProfessionalFieldLicense.name = userLicense?.name;
               newUserProfessionalFieldLicense.licenseID = userLicense?.licenseID;
               newUserProfessionalFieldLicense.expiredAt = userLicense?.expiredAt;
          } else {
               newUserProfessionalFieldLicense.states = responseData.map((data) => data.state);
               newUserProfessionalFieldLicense.stateLicenseIDs = responseData.map((data) => ({
                    id: data.id,
                    state: data.state,
                    licenseID: data.licenseID,
                    expiredAt: data.expiredAt,
               }));
          }
     }

     dispatch(setUserProfessionalFieldLicense(newUserProfessionalFieldLicense));
};

export const fetchSubscriberMyLicensureRequest = () => (dispatch, getState) => {
     const user = getState().subscriber.user;

     dispatch(setIsLoading(true));

     callApi(API_SUBSCRIBER_USER_PROFESSIONAL_FIELD_LICENSE_DETAIL.replace(':userId', user.id), 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               dispatch(setUserProfessionalFieldLicenseResponse(response.data));
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};

export const updateSubscriberMyLicensureRequest = (newValues, setSubmitting, setShowEdit) => (dispatch) => {
     dispatch(setIsWaiting(true));
     callApi(API_SUBSCRIBER_USER_PROFESSIONAL_FIELD_LICENSE, 'PUT', newValues)
          .then((response) => {
               setSubmitting(false);

               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               if (newValues.stateLicenseIDs) {
                    dispatch(setUserProfessionalFieldLicense(newValues));
               } else {
                    newValues.state = null;
                    newValues.licenseID = response.data[0]?.licenseID;
                    newValues.name = response.data[0]?.name;
                    dispatch(setUserProfessionalFieldLicense(newValues));
               }

               setShowEdit(false);
               toast.success('Update successfully');
          })
          .finally(() => {
               dispatch(setIsLoading(false));
               dispatch(setIsWaiting(false));
          });
};

export const changeCountryOfLicensure = (nextDispatch) => () => {
     const { event, values, setValues } = nextDispatch;

     const newState = cloneDeep(event);

     if (!values.stateLicenseIDs) {
          values.stateLicenseIDs = [];
     }

     const newStateLicenseIDs = newState?.map((el) => {
          const foundEl = values?.stateLicenseIDs?.find((stateLicenseId) => stateLicenseId.state === el.value);
          return foundEl || { state: el.value, licenseID: '', name: '' };
     });

     const newValues = {
          ...values,
          state: newState,
          stateLicenseIDs: newStateLicenseIDs,
     };

     setValues(newValues);
};
